import { useContext } from 'react';
//@ts-ignore
import { InlineSkeleton } from '@mindtickle/skeleton';
import { LOADER_STYLES } from './constants';
import styled from 'styled-components';

//@ts-ignore
import mixins, { tokens, theme } from '@mindtickle/styles/lib';
import { LocalAuthContext, TLocalAuthContext } from '../../Auth';

const StyledHeaderLoaderWrp = styled.header`
  ${mixins.clearfix()};
  padding: 16px 24px;
  background-color: ${tokens.bgTokens.COLOR_BG_DEFAULT};
  box-shadow: ${theme.boxShadow.LEVEL1};
  .logo-wrp {
    float: left;
    display: flex;
    max-width: 550px;
    min-width: 250px;
    align-items: center;
  }
  .settings-wrp {
    float: right;
    display: flex;
    align-items: center;
  }
  .center-wrp {
    margin: 0 30%;
    text-align: center;
  }
  .ant-skeleton.ant-skeleton-element.ant-skeleton-active {
    cursor: progress;
    display: inline-block;
    width: auto;
  }
`;

const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  flex: 0 1 30%;
  padding: 0;
  max-width: 550px;
  min-width: 250px;
  float: left;
  a,
  a:focus,
  a:hover {
    text-decoration: none;
  }
  .companyNameLogoBlock {
    display: flex;
    align-items: center;
    .componayLogo {
      margin: 0 12px 0 0;
      max-width: 200px;
      height: 32px;
      img {
        max-width: 200px;
        height: 100%;
      }
    }
    .companyName {
      ${mixins.h3()};
      line-height: 32px;
      ${mixins.truncate('200px')};
      display: block;
    }
  }
  .typeOfSite {
    margin: 6px 0 6px 16px;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: ${tokens.bgTokens.COLOR_BG_WARNING};
    ${mixins.smallBlackText()};
    color: ${tokens.textTokens.COLOR_TEXT_WARNING};
    flex: 0 1 auto;
  }
`;

const {
  THUMBNAIL_STYLES,
  SITE_INFO_STYLES,
  CENTER_TAB_STYLES,
  SEARCH_BAR_STYLES,
  SITE_THUMBNAIL_STYLES,
  SMALL_SETTINGS_STYLES,
} = LOADER_STYLES;

const Logo = ({ company }: { company: TLocalAuthContext['company'] }) => (
  <StyledLogo>
    <div className="companyNameLogoBlock">
      {company.logo && (
        <div className="componayLogo">
          <img src={company.logo} alt="companyLogo" />
        </div>
      )}

      <div className="companyName">{company.name}</div>
    </div>
    <div className="typeOfSite">Admin</div>
  </StyledLogo>
);

const LogoLoader = () => (
  <div className="logo-wrp">
    <InlineSkeleton style={SITE_THUMBNAIL_STYLES} />
    <InlineSkeleton style={SITE_INFO_STYLES} />
    <InlineSkeleton style={SITE_INFO_STYLES} />
  </div>
);

const AdminHeaderLoader = () => {
  const auth = useContext(LocalAuthContext);
  const company = auth?.company;
  return (
    <StyledHeaderLoaderWrp>
      {company ? <Logo company={company} /> : <LogoLoader />}
      <div className="settings-wrp">
        <InlineSkeleton style={SEARCH_BAR_STYLES} />
        <InlineSkeleton style={SMALL_SETTINGS_STYLES} />
        <InlineSkeleton style={SMALL_SETTINGS_STYLES} />
        <InlineSkeleton style={THUMBNAIL_STYLES} />
      </div>
      <div className="center-wrp">
        <InlineSkeleton style={CENTER_TAB_STYLES} />
        <InlineSkeleton style={CENTER_TAB_STYLES} />
        <InlineSkeleton style={CENTER_TAB_STYLES} />
      </div>
    </StyledHeaderLoaderWrp>
  );
};
export default AdminHeaderLoader;
